module.exports = __webpack_public_path__ + "static/media/cpg_kate_campaign_platforms.7d229542.png";